import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { get, throttle } from 'lodash';
import { NotificationManager } from 'react-notifications';
import store from './store';
import App from './App';

window.Promise = Promise;

/* eslint-disable react/jsx-filename-extension */

const Container = () => (
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
);

const serverErrorNotification = throttle(
  () => NotificationManager.error('An unexpected error occurred'),
  2000
);
const clientErrorNotification = throttle(
  () =>
    NotificationManager.error(
      'An error occurred, please check the provided input and try again'
    ),
  2000
);
const connectionNotification = throttle(
  () =>
    NotificationManager.error(
      'You may be offline, please check your internet connection and try again'
    ),
  2000
);

window.addEventListener('unhandledrejection', e => {
  const { reason } = e.detail;

  if (get(reason, 'config.baseURL') === '/api') {
    if (reason.handled) return;

    const status = get(reason, 'response.status', null);

    if ((status >= 500 && status < 600) || status === 404) {
      serverErrorNotification();
    } else if (status >= 400 && status < 500) {
      clientErrorNotification();
    } else if (status === null) {
      connectionNotification();
    }
  }
});

ReactDOM.render(<Container />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js